// extracted by mini-css-extract-plugin
export default {"badge":"ExternalBookingBadge_badge__pEnQS"};